$(document).ready(function () {
      
    $.validator.addMethod(
      "email",
      function (value) {
        return /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i.test(value);
      },
      "Please enter a valid email address."
    );
    $.validator.addMethod(
      "lettersonly",
      function (value, element) {
        return this.optional(element) || /^[a-z]+$/i.test(value);
      },
      "Please enter letters only."
    );
  
    $("#newsletter-footer").validate({
      rules: {
        "contact[email]": {
          required: true,
          email: true,
        },
      },
      onkeyup: false,
      errorPlacement: function (error, element) {
        return true;
      },
    });
    $("#search-form").validate({
      rules: {
        q: {
          required: true,
          normalizer: function (value) {
            // Note: the value of `this` inside the `normalizer` is the corresponding
            // DOMElement. In this example, `this` reference the `username` element.
            // Trim the value of the input
            return $.trim(value);
          },
        },
      },
      onkeyup: false,
      errorPlacement: function (error, element) {
        return true;
      },
    });
    $("#create_customer").validate({
      rules: {
        "customer[first_name]": {
          required: true,
          lettersonly: true,
        },
        "customer[last_name]": {
          required: true,
          lettersonly: true,
        },
        "customer[email]": {
          required: true,
          email: true,
        },
        "customer[password]": {
          required: true,
        },
      },
      onkeyup: false,
      errorElement: "span",
    });
    $("#customer_login").validate({
      rules: {
        "customer[email]": {
          required: true,
          email: true,
        },
        "customer[password]": {
          required: true,
        },
      },
      onkeyup: false,
      errorElement: "span",
    });
    $("#RecoverPasswordForm form").validate({
      rules: {
        email: {
          required: true,
          email: true,
        },
      },
      onkeyup: false,
      errorElement: "span",
    });
    $("#ResetPasswordForm form").validate({
      rules: {
        "customer[password]": {
          required: true,
        },
        "customer[password_confirmation]": {
          required: true,
          equalTo: "#ResetPassword",
        },
      },
      onkeyup: false,
      errorElement: "span",
      messages: {
        "customer[password_confirmation]": {
          equalTo: "Enter Confirm Password Same as Password",
        },
      },
    });
    $("#ActiveAccountForm form").validate({
      rules: {
        "customer[password]": {
          required: true,
        },
        "customer[password_confirmation]": {
          required: true,
          equalTo: "#CustomerPassword",
        },
      },
      onkeyup: false,
      errorElement: "span",
      messages: {
        "customer[password_confirmation]": {
          equalTo: "Enter Confirm Password Same as Password",
        },
      },
    });
    $("#address_form_new").validate({
      rules: {
        "address[first_name]": {
          required: true,
          lettersonly: true,
        },
        "address[last_name]": {
          required: true,
          lettersonly: true,
        },
        "address[address1]": {
          required: true,
        },
        "address[city]": {
          required: true,
        },
        "address[country]": {
          required: true,
        },
        "address[province]": {
          required: true,
        },
        "address[zip]": {
          required: true,
        },
      },
      onkeyup: false,
      errorElement: "span",
    });
    $('[data-edit-form="EditForm"] form').each(function () {
      var form = $(this);
      var form_id = form.attr("id");
      $("#" + form_id).validate({
        rules: {
          "address[first_name]": {
            required: true,
            lettersonly: true,
          },
          "address[last_name]": {
            required: true,
            lettersonly: true,
          },
          "address[address1]": {
            required: true,
          },
          "address[city]": {
            required: true,
          },
          "address[country]": {
            required: true,
          },
          "address[province]": {
            required: true,
          },
          "address[zip]": {
            required: true,
          },
        },
        onkeyup: false,
        errorElement: "span",
      });
    });
  });
  